import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  PropertySelectorState,
  PropertySelectorSwitchStatus,
  propertySelectorFeatureKey,
} from '@dashboards/store/reducers/property-selector.reducer';

export const selectPropertySelectorState = createFeatureSelector<PropertySelectorState>(propertySelectorFeatureKey);

export const selectPropertySelectorSwitchStatus = createSelector(
  selectPropertySelectorState,
  state => state.propertySelectorSwitchStatus
);

export const selectSelectedPortfolioId = createSelector(selectPropertySelectorState, state =>
  state.propertySelectorSwitchStatus == PropertySelectorSwitchStatus.COLLECTION && !state.singleModeEnabled
    ? -1
    : state.portfolioId
);

export const selectSelectedPropertyIds = createSelector(selectPropertySelectorState, state => state.propertyIds);
export const selectIsAllPropertiesSelected = createSelector(
  selectPropertySelectorState,
  state => state.allPropertiesSelected
);
export const selectJoinedProperties = createSelector(selectPropertySelectorState, state => state.joinProperties);
export const selectPropertySingleMode = createSelector(selectPropertySelectorState, state => state.singleModeEnabled);

export const selectSelectedCollectionIds = createSelector(selectPropertySelectorState, state => state.collectionIds);
export const selectIsAllCollectionsSelected = createSelector(
  selectPropertySelectorState,
  state => state.allCollectionsSelected
);

export const selectPortfolioUPPDState = createSelector(selectPropertySelectorState, state => state.portfolioUppdState);
export const selectCollectionUPPDState = createSelector(
  selectPropertySelectorState,
  state => state.collectionUppdState
);
